import { Box } from "@mui/joy";
import fullLogo from "./corkatlas_logo.png";
import smallLogo from "./corkatlas_square_logo.png";
import { useMediaQuery } from "@mui/material";
import { useNavigate } from "react-router-dom";

function HeaderLogo() {
  const isMobile = useMediaQuery("(max-width:600px)");
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={() => navigate("/")}
    >
      <img
        src={isMobile ? smallLogo : fullLogo}
        style={{
          width: isMobile ? "60px" : "180px",
          height: isMobile ? "60px" : "70px",
          userSelect: "none",
        }}
        alt="logo"
      />
    </Box>
  );
}

export default HeaderLogo;
